
import authStore from './authStore';
import userStore from './userStore';

const stores = {
    userStore,
    authStore
};

export default stores;